import React from 'react';
import { Upload2 } from '../../../../components/Svg/Svg';

export default function UploadBox({ onFileSelect, fileLoadErrors }) {
    return (
        <div className="upload-box__wrapper">
            <p className="upload-box__title">No data uploaded</p>
            <p className="upload-box__sub-title">
                Seems that you have no data here yet. Please upload data using
                button below
            </p>
            <input
                type="file"
                name="upload-table"
                id="upload-table"
                className="input-file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={onFileSelect}
            />
            <label className="upload-box__button" htmlFor="upload-table">
                <Upload2 />
                <span className="upload-box__button-text">Upload data</span>
            </label>
            {fileLoadErrors.isWrongFileType && (
                <p style={{ marginTop: '20px', color: 'red' }}>
                    Wrong file type
                </p>
            )}
        </div>
    );
}
